import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { createRepository } from '../../../dto/repositoryFactory';
import { IListOrderFetchParams, IOrder } from '../../../dto';
import { ApiResponse, IListResponse, MN_ORDERS } from '../../../common';
import { AxiosError } from 'axios';
import { handleAxiosError } from '../../../utils';
import dayjs from '@jobcost-monorepo/dayjs-config';

const HookComponentActivity: React.FC = () => {
  const { setValue, watch, formState } = useFormContext();
  const jobId = watch('jobId');
  const orderId = watch('orderId');
  const startDate = watch('startDate');

  const handleChangeJobId = async () => {
    if (jobId === null || jobId === undefined) {
      setValue('orderId', null);
      return;
    }

    if (formState.dirtyFields['jobId']) {
      const repository = createRepository<IOrder, IListOrderFetchParams>(
        MN_ORDERS,
      );
      const order = await repository
        .getMany({ jobId })
        .then((response: ApiResponse<IListResponse<IOrder>>) => {
          if (response?.data && response?.data.data?.length === 1) {
            return response?.data.data[0];
          }
        })
        .catch((err: AxiosError) => handleAxiosError(err));

      if (order) {
        setValue('orderId', order.id, { shouldDirty: true });
        setValue('resourceId', order.resourceId, { shouldDirty: true });
      }
    }
  };

  const handleChangeOrderId = async () => {
    if (orderId === null || orderId === undefined) {
      setValue('resourceId', null);
      return;
    }

    if (formState.dirtyFields['orderId']) {
      const repository = createRepository<IOrder, IListOrderFetchParams>(
        MN_ORDERS,
      );
      repository
        .get(orderId)
        .then((response: ApiResponse<IOrder>) => {
          if (response?.data) {
            const order = response?.data;
            setValue('resourceId', order?.resourceId, { shouldDirty: true });
          }
        })
        .catch((err: AxiosError) => handleAxiosError(err));
    }
  };

  const handleChangeStartDate = () => {
    if (formState.dirtyFields['startDate']) {
      if (startDate === null || startDate === undefined) {
        setValue('endDate', null);
        return;
      }
      const endDate = dayjs.utc(startDate).endOf('month').toISOString();
      setValue('endDate', endDate, { shouldDirty: true });
    }
  };

  useEffect(() => {
    handleChangeJobId().then();
  }, [jobId]);

  useEffect(() => {
    handleChangeOrderId().then();
  }, [orderId]);

  useEffect(() => {
    handleChangeStartDate();
  }, [startDate]);

  return <div />;
};

export default HookComponentActivity;
